import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { exportPlayerPlaylogCsv } from '../../services'
import type { ExportPlayerPlaylogCsvRequest } from '../../../type'

export function useMutationExportPlayerPlaylogCsv() {
	return useMutation({
		mutationFn: async (payload: ExportPlayerPlaylogCsvRequest) => {
			return await exportPlayerPlaylogCsv(payload)
		},
		onSuccess: (blob, variables) => {
			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url

			const filename = variables.filename || 'player_playlog'
			link.download = `${filename}.csv`

			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)

			window.URL.revokeObjectURL(url)

			toast.success('ดาวน์โหลดไฟล์ CSV สำเร็จ')
		},
		onError: (error) => {
			console.error('CSV export error:', error)
			toast.error('การดาวน์โหลดไฟล์ CSV ล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
